module.exports = __webpack_public_path__ + "static/img/safe-tip-bg.3d93aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/safe-tip-bg.png
// module id = tZlC
// module chunks = 7